module.exports = __webpack_public_path__ + "static/media/chapterInvestigacion.4e64771e.png";